import _ from 'lodash';
import { AnyAction } from 'redux';
import { entityCollectionDefaultState, EntityCollectionState } from '../entities/types/EntityCollectionState';
import {
    FAILURE_CONFIRM_SEPA_BATCH,
    FAILURE_SEPA_BATCHES,
    FAILURE_SEPA_BATCH_PREVIEW,
    FETCH_SEPA_BATCHES,
    REQUEST_CONFIRM_SEPA_BATCH,
    REQUEST_SEPA_BATCHES,
    REQUEST_SEPA_BATCH_PREVIEW,
    SUCCESS_CONFIRM_SEPA_BATCH,
    SUCCESS_SEPA_BATCHES,
    SUCCESS_SEPA_BATCH_PREVIEW,
} from './actions';

export function sepaBatchReducerAdmin(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case FETCH_SEPA_BATCHES:
            return _.assign({}, state, {
                lastFilter: {
                    pageable: action.pageable,
                    batchNumber: action.batchNumber,
                    confirmedState: action.confirmedState,
                },
            });
        case REQUEST_SEPA_BATCHES:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_SEPA_BATCHES: {
            return _.assign({}, state, {
                isFetching: false,
                items: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_SEPA_BATCHES:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });
        default:
            return state;
    }
}

export function sepaBatchPreviewReducerAdmin(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_SEPA_BATCH_PREVIEW:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_SEPA_BATCH_PREVIEW: {
            return _.assign({}, state, {
                isFetching: false,
                items: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_SEPA_BATCH_PREVIEW:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });
        default:
            return state;
    }
}

export function sepaBatchConfirmReducerAdmin(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_CONFIRM_SEPA_BATCH:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_CONFIRM_SEPA_BATCH: {
            return _.assign({}, state, {
                isFetching: false,
                items: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_CONFIRM_SEPA_BATCH:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });
        default:
            return state;
    }
}
